/* İRYA ürün sayfası: öneri sekmeleri, baloncuk, WhatsApp konumu */
if (!window.__iryaCs) {
      window.__iryaCs = true;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const gapOf = (g) => parseFloat(getComputedStyle(g).columnGap) || 0;
      const activeGrid = (box) => box.querySelector('.irya-cs-panel.is-active .irya-cs-grid');
      const pageW = (g) => g.clientWidth + gapOf(g);

      const upd = (box) => {
        const g = activeGrid(box);
        const nav = box.querySelector('.irya-cs-nav'), dotsEl = box.querySelector('.irya-cs-dots');
        if (!g) { if (nav) nav.hidden = true; if (dotsEl) dotsEl.innerHTML = ''; return; }
        const over = g.scrollWidth > g.clientWidth + 4;
        const p = box.querySelector('[data-irya-prev]'), n = box.querySelector('[data-irya-next]');
        if (nav) nav.hidden = !over;
        if (p) p.disabled = g.scrollLeft <= 4;
        if (n) n.disabled = g.scrollLeft + g.clientWidth >= g.scrollWidth - 4;
        if (!dotsEl) return;
        const pages = over ? Math.max(1, Math.round((g.scrollWidth + gapOf(g)) / pageW(g))) : 0;
        if (dotsEl.children.length !== pages) {
          dotsEl.innerHTML = '';
          for (let i = 0; i < pages; i++) {
            const d = document.createElement('button');
            d.type = 'button'; d.className = 'irya-cs-dot'; d.dataset.iryaPage = i; d.setAttribute('aria-label', (i + 1) + '. sayfa');
            dotsEl.appendChild(d);
          }
        }
        const cur = Math.round(g.scrollLeft / pageW(g));
        Array.from(dotsEl.children).forEach((d, i) => d.classList.toggle('is-active', i === cur));
      };

      const setTab = (box, i) => {
        box.querySelectorAll('.irya-cs-tab').forEach((t) => {
          const on = +t.dataset.iryaTab === i;
          t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on);
        });
        box.querySelectorAll('.irya-cs-panel').forEach((pn) => pn.classList.toggle('is-active', +pn.dataset.panel === i));
        const sub = box.querySelector('.irya-cs-sub');
        if (sub) sub.textContent = i === 1 ? sub.dataset.sub1 : sub.dataset.sub0;
        const g = activeGrid(box);
        if (g) g.scrollLeft = 0;
        upd(box);
      };

      const loadRelated = (box) => {
        const pn = box.querySelector('.irya-cs-panel[data-panel="1"]');
        if (!pn || box.dataset.iryaRel) return;
        box.dataset.iryaRel = 'loading';
        pn.classList.add('is-loading');
        fetch(box.dataset.iryaRelUrl)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const g = doc.querySelector('.irya-cs-panel[data-panel="0"] .irya-cs-grid');
            const tab = box.querySelector('.irya-cs-tab[data-irya-tab="1"]');
            pn.classList.remove('is-loading');
            if (g && g.children.length) {
              pn.replaceChildren(document.importNode(g, true));
              box.dataset.iryaRel = 'ok';
              if (tab) tab.hidden = false;
            } else {
              box.dataset.iryaRel = 'empty';
              if (tab) tab.hidden = true;
              if (!box.querySelector('.irya-cs-panel[data-panel="0"] .irya-cs-grid')) box.hidden = true;
            }
            upd(box);
          })
          .catch(() => { pn.classList.remove('is-loading'); box.dataset.iryaRel = 'empty'; });
      };

      const seen = () => { try { return sessionStorage.getItem('irya-cs-bubble') === '1'; } catch (e) { return false; } };
      const markSeen = () => { try { sessionStorage.setItem('irya-cs-bubble', '1'); } catch (e) {} };
      const intro = (box) => {
        const g = activeGrid(box);
        if (!g || box.dataset.iryaIntro) return;
        box.dataset.iryaIntro = '1';
        const io = new IntersectionObserver((en) => {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          if (!reduce && g.scrollWidth > g.clientWidth + 4 && g.animate) {
            setTimeout(() => {
              g.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-36px)' }, { transform: 'translateX(0)' }],
                        { duration: 1100, easing: 'cubic-bezier(.45,0,.2,1)' });
            }, 600);
          }
          const txt = box.dataset.iryaBubble;
          const every = box.dataset.iryaBubbleEvery === 'true';
          if (!txt || window.__iryaCsBubbleShown || (!every && seen())) return;
          window.__iryaCsBubbleShown = true;
          markSeen();
          const b = document.createElement('div');
          b.className = 'irya-cs-bubble';
          b.textContent = txt;
          b.addEventListener('click', () => b.remove());
          box.appendChild(b);
          requestAnimationFrame(() => requestAnimationFrame(() => b.classList.add('is-on')));
          const ms = (parseFloat(box.dataset.iryaBubbleSec) || 10) * 1000;
          setTimeout(() => { b.classList.remove('is-on'); setTimeout(() => b.remove(), 400); }, ms);
        }, { threshold: 0.6 });
        io.observe(g);
      };

      const init = (box) => {
        if (!box.querySelector('.irya-cs-panel')) return;
        if (!box.dataset.iryaInit) {
          box.dataset.iryaInit = '1';
          if (!box.querySelector('.irya-cs-panel[data-panel="0"] .irya-cs-grid')) {
            const t0 = box.querySelector('.irya-cs-tab[data-irya-tab="0"]');
            if (t0) t0.hidden = true;
            setTab(box, 1);
            loadRelated(box);
          } else {
            const go = () => loadRelated(box);
            ('requestIdleCallback' in window) ? requestIdleCallback(go, { timeout: 2500 }) : setTimeout(go, 1500);
          }
        }
        upd(box);
        intro(box);
      };

      document.addEventListener('click', (e) => {
        const box = e.target.closest('product-recommendations.irya-cs');
        if (!box) return;
        const tab = e.target.closest('[data-irya-tab]');
        if (tab) { setTab(box, +tab.dataset.iryaTab); loadRelated(box); return; }
        const g = activeGrid(box);
        if (!g) return;
        const nb = e.target.closest('[data-irya-prev],[data-irya-next]');
        if (nb) { g.scrollBy({ left: (nb.hasAttribute('data-irya-next') ? 1 : -1) * pageW(g), behavior: 'smooth' }); return; }
        const d = e.target.closest('[data-irya-page]');
        if (d) g.scrollTo({ left: +d.dataset.iryaPage * pageW(g), behavior: 'smooth' });
      });
      document.addEventListener('scroll', (e) => {
        const t = e.target;
        if (t.classList && t.classList.contains('irya-cs-grid')) { const box = t.closest('product-recommendations.irya-cs'); box && upd(box); }
      }, true);

      let raf;
      const scan = () => document.querySelectorAll('product-recommendations.irya-cs').forEach(init);
      const mo = new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(scan); });
      const watch = () => document.querySelectorAll('product-recommendations.irya-cs').forEach((el) => {
        if (!el.dataset.iryaWatch) { el.dataset.iryaWatch = '1'; mo.observe(el, { childList: true }); }
      });
      window.addEventListener('resize', () => document.querySelectorAll('product-recommendations.irya-cs').forEach(upd));
      const mq = window.matchMedia('(max-width: 767px)');
      let waRaf;
      const placeWa = () => {
        const wa = document.getElementById('whatsapp-float-button');
        const card = document.querySelector('.product-sticky-form__card');
        if (!wa) return;
        if (!card || !mq.matches || !card.closest('.irya-sticky-compact')) { wa.style.bottom = ''; return; }
        const top = card.getBoundingClientRect().top;
        if (top <= 0 || top >= window.innerHeight) { wa.style.bottom = ''; return; }
        wa.style.bottom = Math.round(window.innerHeight - top + 10) + 'px';
      };
      const queueWa = () => { cancelAnimationFrame(waRaf); waRaf = requestAnimationFrame(placeWa); };
      const watchWa = () => {
        if (!document.querySelector('.product-sticky-form__card')) return;
        window.addEventListener('scroll', queueWa, { passive: true });
        window.addEventListener('resize', queueWa);
        document.addEventListener('transitionend', (e) => { if (e.target.closest && e.target.closest('.product-sticky-form, .mobile-dock')) queueWa(); }, true);
        mq.addEventListener && mq.addEventListener('change', queueWa);
        queueWa();
      };
      /* Masaüstü: görselin üst noktasını ölç, CSS görseli ekran yüksekliğine göre sınırlar */
      const fitGal = () => {
        const sec = document.querySelector('.irya-fit-gallery');
        if (!sec) return;
        if (!window.matchMedia('(min-width: 1024px)').matches) { sec.style.removeProperty('--irya-gal-top'); return; }
        const top = sec.getBoundingClientRect().top + window.scrollY + (parseFloat(getComputedStyle(sec).paddingTop) || 0);
        if (top > 0 && top < 600) sec.style.setProperty('--irya-gal-top', Math.round(top) + 'px');
      };
      let galT;
      window.addEventListener('resize', () => { clearTimeout(galT); galT = setTimeout(fitGal, 150); });
      window.addEventListener('load', fitGal);
      const markSticky = () => {
        if (document.querySelector('.irya-sticky-compact .product-sticky-form')) document.body.classList.add('irya-has-sticky');
      };
      const start = () => { fitGal(); markSticky(); watch(); scan(); watchWa(); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    }